import { render, staticRenderFns } from "./WheelLock.vue?vue&type=template&id=9c2fe770&"
import script from "./WheelLock.vue?vue&type=script&lang=js&"
export * from "./WheelLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports